import type { AccountRole } from '@workflow/contracts'

/** The roles, as the studio says them: what the person does here, not the column's value. */
export const ROLE_LABEL: Record<AccountRole, string> = {
  admin: 'Administrator',
  staff: 'Staff',
  player: 'Player',
}
